<template>
  <div :class="$style.join">
    <div :class="$style['join-content']">
      <h2 :class="$style['join-title']">
        {{ landingJoin.title }}<span>JOIN US</span>
      </h2>
      <img :src="currentBanner" :class="$style['join-banner']" />
      <div v-if="landingJoin.links" :class="$style['join-links']">
        <a
          v-for="(el, index) in landingJoin.links"
          :key="index"
          :href="el.url"
          target="_blank"
          :class="
            el.subtitle
              ? $style['join-links-bar']
              : $style['join-links-primary']
          "
        >
          <span>{{ el.title }}</span>
          <span v-if="el.subtitle">{{ el.subtitle }}</span>
        </a>
      </div>
    </div>
    <LandingMask :class="$style['join-mask']" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LandingMask from '../LandingMask'

export default {
  name: 'LandingJoin',
  components: {
    LandingMask,
  },
  data() {
    return {
      // 是否为竖屏模式
      isPortraitMode: false,
    }
  },
  computed: {
    ...mapGetters(['landingJoin']),
    // 根据屏幕方向返回对应的banner图片
    currentBanner() {
      if (this.landingJoin.banner) {
        return this.isPortraitMode
          ? this.landingJoin.banner.portrait
          : this.landingJoin.banner.landscape
      }
      return ''
    },
  },
  mounted() {
    // 添加全局事件监听器
    this.$root.$on('screen-info-changed', this.handleScreenInfoChange)
  },
  beforeDestroy() {
    // 移除全局事件监听器
    this.$root.$off('screen-info-changed', this.handleScreenInfoChange)
  },
  methods: {
    // 处理屏幕方向变化的事件监听器
    handleScreenInfoChange(newScreenInfo) {
      if (!newScreenInfo) {
        return
      }
      this.isPortraitMode = newScreenInfo.type !== 'landscape'
    },
  },
}
</script>

<style lang="less" module>
.join {
  .size(100%);

  background: url(./images/bg.jpg) repeat;
  background-size: contain;
  overflow: hidden;

  &-mask::after {
    .size(1.75rem,6.9rem);

    content: '';
    position: absolute;
    background: url('./images/join-decorate-title.png') no-repeat;
    background-size: 100% 100%;
  }

  &-title {
    position: relative;
    display: flex;
    align-items: flex-end;
    gap: 0.14rem;
    font-weight: 700;
    border-bottom: 0.01rem solid #afafaf;
    transition: transform 1s ease;
    transform: translateY(0.5rem);

    span {
      font-weight: 400;
      color: #afafaf;
    }

    &::after {
      .size(4em, 0.05rem);

      content: '';
      position: absolute;
      bottom: -0.03rem;
      left: 0;
      background-color: #ff1325;
    }
  }

  &-banner {
    transition: transform 1s ease;
    transition-delay: 0.3s;
    transform: translateY(0.5rem);
  }

  &-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0.57rem;
    transition: transform 1s ease;
    transition-delay: 0.6s;
    transform: translateY(0.5rem);

    a {
      text-decoration: none;
    }

    &-primary {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      background: url('./images/btn-primary.png') no-repeat;
      background-size: 100% 100%;
      color: #fff;
      font-size: 0.28rem;
      font-weight: 700;
      cursor: pointer;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(255, 255, 255, 0.4) 50%,
          transparent 100%
        );
        transition: left 0.6s ease;
        pointer-events: none;
      }

      &:hover::before {
        left: 100%;
      }

      span {
        position: relative;
        z-index: 2;
      }
    }

    &-bar {
      position: relative;
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: 0.15rem;
      margin-top: 0.26rem;
      padding-left: 0.34rem;
      color: @landing-text-color;
      cursor: pointer;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(255, 19, 37, 0.05) 50%,
          transparent 100%
        );
        transition: left 0.6s ease;
        pointer-events: none;
      }

      &:hover::before {
        left: 100%;
      }

      span {
        position: relative;
        z-index: 2;
      }

      span:first-child {
        font-size: 0.32rem;
        font-weight: 700;
      }

      span:last-child {
        font-size: 0.24rem;
      }
    }
  }
}

// fullpage.js 完全进入页面时的动画效果
:global(.fp-completely) {
  .join-title {
    transform: translateY(0);
  }

  .join-banner {
    transform: translateY(0);
  }

  .join-links {
    transform: translateY(0);
  }
}

// 横屏
:global(.landing-screen-landscape) {
  .join {
    &-mask::after {
      top: 0.85rem;
      right: 0.7rem;
    }

    &-content {
      position: absolute;
      top: 2.29rem;
      left: 50%;
      transform: translateX(-0.22rem);
    }

    &-banner {
      .size(9.48rem, 6.78rem);

      position: absolute;
      top: -0.6rem;
      left: -9.48rem - 0.35;
      object-fit: contain;
    }

    &-title {
      width: 3rem;
      font-size: 0.36rem;
      padding-bottom: 0.1rem;

      span {
        font-size: 0.24rem;
      }
    }

    &-links {
      width: 6.4rem;

      &-primary {
        .size(2.96rem,0.76rem);
      }

      &-bar {
        .size(100%, 1.2rem);

        background: url('./images/landscape-btn-bar.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}

// 竖屏
:global(.landing-screen-portrait) {
  .join {
    &-mask::after {
      top: 1.3rem;
      right: 0;
    }

    &-content {
      width: 9.03rem;
      margin: 0 auto;
      padding-top: 2.9rem;
    }

    &-banner {
      .size(100%, 5.81rem);

      object-fit: contain;
    }

    &-title {
      width: 3.3rem;
      font-size: 0.42rem;
      padding-bottom: 0.15rem;

      span {
        font-size: 0.28rem;
      }
    }

    &-links {
      width: 7.96rem;
      margin-left: 0.85rem;

      &-primary {
        .size(3.37rem,0.76rem);
      }

      &-bar {
        .size(100%, 1.2rem);

        background: url('./images/portrait-btn-bar.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
